import { Button } from '@/components/common/Button/Button';
import { useAskInputContext } from '@/contexts/askInputSuggestion';
import { useOpenAskModal } from '@/contexts/askModal';
import { t } from 'i18next';
import { useMemo } from 'react';
import { GoogleSuggestion } from './GoogleSuggestion';
import { UserSuggestion } from './UserSuggestion';
interface AskInputSuggestionProps {
	placeholder?: string;
	buttonText?: string;
	suggestionOnTop?: boolean;
	followUpConversationId?: string | null; // conversation id of the follow up question
	conversationId?: string | null; // conversation id of the conversation
}

export const AskInputSuggestion = ({
	placeholder = "What's going on",
	buttonText = t('common:askNow'),
	suggestionOnTop = false,
	followUpConversationId,
	conversationId,
}: AskInputSuggestionProps) => {
	const {
		question,
		handleChange,
		handleGetSuggestions,
		handleAskNow,
		isAskNowLoading,
		showSuggestions,
		googleSuggestions,
		followUpQuestions,
		isLoading,
		handleSelectSuggestion,
	} = useAskInputContext();

	const { onClose } = useOpenAskModal();

	const paddingTop = useMemo(() => {
		if (question) {
			return googleSuggestions.length > 4 ? 'pt-[35px]' : 'pt-0';
		}
		return (followUpQuestions || []).length > 4 ? 'pt-5' : 'pt-0';
	}, [googleSuggestions, followUpQuestions, question]);

	const suggestionContent =
		showSuggestions &&
		(question ? (
			<GoogleSuggestion
				googleSuggestions={googleSuggestions}
				handleSelectSuggestion={handleSelectSuggestion}
				paddingTop={paddingTop}
				suggestionOnTop={suggestionOnTop}
			/>
		) : (
			<UserSuggestion
				followUpQuestions={followUpQuestions || []}
				handleSelectSuggestion={handleSelectSuggestion}
				isLoading={isLoading}
				paddingTop={paddingTop}
				suggestionOnTop={suggestionOnTop}
			/>
		));

	return (
		<div className="flex flex-col gap-4">
			{suggestionOnTop && suggestionContent}

			<div className="flex items-center gap-2 justify-between bg-green border-1 border-grey-2 rounded-full pl-[25px] pr-[5px] py-2.5 h-[42px] z-10">
				<input
					type="text"
					placeholder={placeholder}
					className="flex-1 bg-transparent outline-none text-gray-700 placeholder:text-gray-500 truncate"
					value={question}
					onChange={handleChange}
					onFocus={handleGetSuggestions}
					aria-label="Ask question"
				/>
				<Button
					variant="dark"
					className="h-[30px] px-2.5 py-1.5"
					onClick={() =>
						handleAskNow({
							onCloseModal: onClose,
							followUpConversationId,
							conversationId,
						})
					}
					disabled={isAskNowLoading || question.trim() === ''}
					loading={isAskNowLoading}
				>
					{buttonText}
				</Button>
			</div>

			{!suggestionOnTop && suggestionContent}
		</div>
	);
};
